export enum ErrorsCode {
  BANNERS_NOT_FOUND = 'BANNERS_NOT_FOUND',
  BOOKING_RULES_NOT_FOUND = 'BOOKING_RULES_NOT_FOUND',
  CONFIRM_PAYMENT_REVOLUT_FAILED = 'CONFIRM_PAYMENT_REVOLUT_FAILED',
  CONFIRM_PAYMENT_WORLDLINE_FAILED = 'CONFIRM_PAYMENT_WORLDLINE_FAILED',
  CHECKOUT_PAYMENT_STATUS_NOT_FOUND = 'CHECKOUT_PAYMENT_STATUS_NOT_FOUND',
  COOKIE_NOT_FOUND = 'COOKIE_NOT_FOUND',
  DELETE_CURRENT_USER_AUTH = 'DELETE_CURRENT_USER_AUTH',
  ERROR_DELETING_PROPERTY_LIKE = 'ERROR_DELETING_PROPERTY_LIKE',
  ERROR_GETTING_PROPERTY_LIKE = 'ERROR_GETTING_PROPERTY_LIKE',
  ERROR_GETTING_PROPERTY_LIKES = 'ERROR_GETTING_PROPERTY_LIKES',
  ERROR_GETTING_THEMES = 'ERROR_GETTING_THEMES',
  ERROR_SAVING_LIST_LAST_SEEN_PROPERTIES = 'ERROR_SAVING_LIST_LAST_SEEN_PROPERTIES',
  ERROR_SAVING_PROPERTY_LIKE = 'ERROR_SAVING_PROPERTY_LIKE',
  FIND_BY_BANNER_ID_PROPERTIES_NOT_FOUND = 'FIND_BY_BANNER_ID_PROPERTIES_NOT_FOUND',
  FIND_BY_IDS_PROPERTIES_NOT_FOUND = 'FIND_BY_IDS_PROPERTIES_NOT_FOUND',
  FORBIDDEN_COOKIE_OPERATION = 'FORBIDDEN_COOKIE_OPERATION',
  FORBIDDEN_DRIVER_OPERATION = 'FORBIDDEN_DRIVER_OPERATION',
  FORBIDDEN_REPOSITORY_METHOD = 'FORBIDDEN_REPOSITORY_METHOD',
  FORBIDDEN_UPDATE_AVAILABILITY_WITHOUT_NIGHTS = 'FORBIDDEN_UPDATE_AVAILABILITY_WITHOUT_NIGHTS',
  GUEST_ROOMING_LIST_CREATION_FAILED = 'GUEST_ROOMING_LIST_CREATION_FAILED',
  INVALID_APM_KIND_VALUE_MISMATCH = '[APM] INVALID_APM_KIND_VALUE_MISMATCH',
  INVALID_BANNER_SUBTYPE = 'INVALID_BANNER_SUBTYPE',
  INVALID_PAYMENT_METHOD_DATA = 'INVALID_PAYMENT_METHOD_DATA',
  INVOICE_REQUEST_RESPONSE_NOT_FOUND = 'INVOICE_REQUEST_RESPONSE_NOT_FOUND',
  LIST_PROMOTIONS_NOT_FOUND = 'LIST_PROMOTIONS_NOT_FOUND',
  LIST_TOP_DESTINATIONS_NOT_FOUND = 'LIST_TOP_DESTINATIONS_NOT_FOUND',
  LOCAL_STORAGE_GENERIC_ERROR = 'LOCAL_STORAGE_GENERIC_ERROR',
  LOCAL_STORAGE_NOT_FOUND = 'LOCAL_STORAGE_NOT_FOUND',
  LOCATION_NOT_FOUND = 'LOCATION_NOT_FOUND',
  LOGOUT_ERROR = 'LOGOUT_ERROR',
  MISSING_AUTH_TOKEN = 'MISSING_AUTH_TOKEN',
  MISSING_BODY_SCHEMA = 'MISSING_BODY_SCHEMA',
  MISSING_FRAMEWORK_REQUEST = 'MISSING_FRAMEWORK_REQUEST',
  MISSING_FRAMEWORK_RESPONSE = 'MISSING_FRAMEWORK_RESPONSE',
  MISSING_HEADER = 'MISSING_HEADER',
  MISSING_HEADERS = 'MISSING_HEADERS',
  MISSING_LANGUAGE = 'MISSING_LANGUAGE',
  MISSING_LIST_LAST_SEEN_PROPERTIES = 'MISSING_LIST_LAST_SEEN_PROPERTIES',
  MISSING_MARKET = 'MISSING_MARKET',
  MISSING_PARTIAL_SEARCH_INFO = 'MISSING_PARTIAL_SEARCH_INFO',
  MISSING_QUERY_PARAM = 'MISSING_QUERY_PARAM',
  MISSING_QUERY_SCHEMA = 'MISSING_QUERY_SCHEMA',
  MISSING_RESPONSE_SCHEMA = 'MISSING_RESPONSE_SCHEMA',
  MISSING_SEARCH_INFO = 'MISSING_SEARCH_INFO',
  NODE_NAVIGATOR_NOT_SUPPORTED = 'NODE_NAVIGATOR_NOT_SUPPORTED',
  NODE_SCREEN_NOT_SUPPORTED = 'NODE_SCREEN_NOT_SUPPORTED',
  PAYMENT_METHODS_NOT_FOUND = 'PAYMENT_METHODS_NOT_FOUND',
  PURCHASE_ID_CREATION_FAILED = 'PURCHASE_ID_CREATION_FAILED',
  RELATED_PROPERTIES_NOT_FOUND = 'RELATED_PROPERTIES_NOT_FOUND',
  SEARCH_PROPERTIES_ERROR = 'SEARCH_PROPERTIES_ERROR',
  SPECIAL_REQUEST_RESPONSE_STATUS_NOT_FOUND = 'SPECIAL_REQUEST_RESPONSE_STATUS_NOT_FOUND',
  SUBSCRIPTION_FAILED = 'SUBSCRIPTION_FAILED',
  TOP_DESTINATION_AT_LEAST_ONE_IMAGE = 'TOP_DESTINATION_AT_LEAST_ONE_IMAGE',
  TOP_DESTINATION_IMAGE_NOT_FOUND = 'TOP_DESTINATION_IMAGE_NOT_FOUND',
  UNTRUSTED_PAYMENT_CALLBACK_DOMAIN = 'UNTRUSTED_PAYMENT_CALLBACK_DOMAIN',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  WINDOW_HEADER_NOT_SUPPORTED = 'WINDOW_HEADER_NOT_SUPPORTED',
  VOUCHER_PAYMENT_CONFIRMATION_FAILED = 'VOUCHER_PAYMENT_CONFIRMATION_FAILED',
  VOUCHER_PAYMENT_STATUS_NOT_FOUND = 'VOUCHER_PAYMENT_STATUS_NOT_FOUND',
}
